import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getPickupBranchDetails } from "../../redux/features/restaurants/restaurantThunks";
import { setOrderType } from "../../redux/features/order/orderSlice";

const CateringAddNewAddress = ({
  type = "address",
  customStyles = {},
  branchId = null,
  restaurantId = null,
  className = "",
  setShowAddressForm = null,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleClick = async () => {
    if (type === "address") {
      if (setShowAddressForm) {
        setShowAddressForm(true);
      }
    } else if (type === "order") {
      if (branchId && restaurantId) {
        await dispatch(getPickupBranchDetails(branchId));
      }
      dispatch(setOrderType("asap"));

      navigate("/place-order");
    }
  };

  if (type === "address") {
    return (
      <button
        type="button"
        onClick={handleClick}
        className={`text-white font-bold bg-amber-800 rounded-xl h-12 w-full sm:w-[160px] focus:ring-1 focus:ring-amber-800 focus:outline-none hover:bg-amber-900 ${className}`}
        style={customStyles}
      >
        Add New Address
      </button>
    );
  }

  return (
    <div style={customStyles} className="w-full">
      <div
        onClick={handleClick}
        className="flex flex-col items-center justify-center bg-gray-50 border-2 border-slate-300 p-4 rounded-xl w-full h-[162px] mt-3 sm:mt-0 gap-2 cursor-pointer hover:border-amber-100 transition-colors duration-300"
      >
        <svg
          id="Group_975"
          data-name="Group 975"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          width="42"
          height="42"
          viewBox="0 0 42 42"
        >
          <defs>
            <clipPath id="clip-path">
              <rect
                id="Rectangle_306"
                data-name="Rectangle 306"
                width="42"
                height="42"
                fill="#fafafa"
              />
            </clipPath>
          </defs>
          <g id="Group_974" data-name="Group 974" clipPath="url(#clip-path)">
            <path
              id="Path_1209"
              data-name="Path 1209"
              d="M20.988,0A20.881,20.881,0,0,1,35.831,6.156h.012a21,21,0,0,1,0,29.688l-.123.123a20.975,20.975,0,0,1-29.565-.123H6.144a21,21,0,0,1,0-29.688l.135-.123A20.926,20.926,0,0,1,20.988,0M18.665,10.862h0v7.8H10.85a2.335,2.335,0,1,0,0,4.669h7.815v7.8a2.329,2.329,0,1,0,4.657,0v-7.8h7.815a2.335,2.335,0,1,0,0-4.669H23.322v-7.8a2.329,2.329,0,1,0-4.657,0M32.551,9.449h0a16.347,16.347,0,0,0-23-.1l-.1.1a16.346,16.346,0,0,0,0,23.1H9.437a16.347,16.347,0,0,0,23,.1l.1-.1a16.316,16.316,0,0,0,0-23.1Z"
              fill="#fafafa"
            />
          </g>
        </svg>
        <h4 className="text-white text-lg text-center">
          Place New
          <br /> Order
        </h4>
      </div>
    </div>
  );
};

export default CateringAddNewAddress;
